import { useState, type FormEvent } from 'react';
import { ApiError, Button, ErrorNote, Field, Input, useAuth } from '@mobi/web';

export function Auth() {
  const { login, signup } = useAuth();
  const [mode, setMode] = useState<'login' | 'signup'>('login');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (mode === 'login') await login({ email, password });
      else await signup({ name, email, phone, password, role: 'driver' });
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : err instanceof Error
            ? err.message
            : 'não foi possível entrar',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="h-app overflow-y-auto bg-surface">
      <div className="mx-auto flex min-h-full w-full max-w-md flex-col justify-center px-6 py-12">
        <div className="mb-10">
          <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand">
            <svg viewBox="0 0 24 24" className="h-8 w-8 fill-brand-ink" aria-hidden="true">
              <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 2.2a7.8 7.8 0 0 1 7.6 6.1h-4.2A3.8 3.8 0 0 0 12 8.3a3.8 3.8 0 0 0-3.4 2H4.4A7.8 7.8 0 0 1 12 4.2ZM4.3 12.5h4.4a3.8 3.8 0 0 0 2.2 2.4v4.7a7.8 7.8 0 0 1-6.6-7.1Zm8.8 7.1v-4.7a3.8 3.8 0 0 0 2.2-2.4h4.4a7.8 7.8 0 0 1-6.6 7.1ZM12 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold tracking-tight">
            {mode === 'login' ? 'Bem-vindo de volta' : 'Criar sua conta'}
          </h1>
          <p className="mt-2 text-muted">
            {mode === 'login'
              ? 'Entre para começar a rodar.'
              : 'Depois você envia seus documentos.'}
          </p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          {mode === 'signup' && (
            <>
              <Field label="Nome completo">
                <Input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoComplete="name"
                  required
                  minLength={3}
                  placeholder="Maria Silva"
                />
              </Field>
              <Field label="Celular" hint="com DDD">
                <Input
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  inputMode="tel"
                  autoComplete="tel"
                  required
                  placeholder="(11) 99999-9999"
                />
              </Field>
            </>
          )}

          <Field label="E-mail">
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              placeholder="voce@email.com"
            />
          </Field>

          <Field label="Senha" hint={mode === 'signup' ? 'mínimo 8 caracteres' : undefined}>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              required
              minLength={mode === 'signup' ? 8 : undefined}
            />
          </Field>

          {error && <ErrorNote>{error}</ErrorNote>}

          <Button type="submit" size="lg" full loading={busy}>
            {mode === 'login' ? 'Entrar' : 'Criar conta'}
          </Button>
        </form>

        <button
          type="button"
          onClick={() => {
            setMode(mode === 'login' ? 'signup' : 'login');
            setError(null);
          }}
          className="mt-6 text-center text-sm text-muted underline underline-offset-4"
        >
          {mode === 'login' ? 'Não tenho conta ainda' : 'Já tenho conta'}
        </button>
      </div>
    </div>
  );
}
